import * as React from 'react';
import { TopModelMergeNameTransformed, } from '@goldwasserexchange/react-topmodel';
import { defaultListElementBaseTopModelsObject } from './topmodels';
export function DefaultListElementBaseTopModelsProvider(props) {
    var children = props.children, order = props.order, transformBeforeFn = props.transformBeforeFn;
    return (React.createElement(TopModelMergeNameTransformed, { topModels: defaultListElementBaseTopModelsObject, order: order, transformBeforeFn: transformBeforeFn }, children));
}
